/* ============================================================
   custom.js — このストア固有のカスタムJS
   2026-08-20 五十嵐 新規作成

   全案件共通の規約として、テーマ本体（*.bundle.js / theme.js 等）には手を入れず、
   追加のスクリプトはすべてこのファイルに追記する。
   読み込みは layout/theme.liquid で行っている。
   ============================================================ */

/* ------------------------------------------------------------
   デニムフィットガイドの背景動画
   2026-08-20 五十嵐 追加

   画面幅に応じてPC用・スマホ用のどちらか一方だけを読み込む。
   src を最初から書いてしまうと両方が落ちてくるため、Liquid側では
   data 属性に候補を持たせ、実際の読み込みはここで決める。
   動きを抑える設定にしている環境では動画を読み込まず、ポスター画像のまま止める。
   ------------------------------------------------------------ */
(function () {
  var PC_QUERY = '(min-width: 750px)';

  function setup(video) {
    if (video.dataset.rbVideoReady === '1') return;

    var isPc = window.matchMedia(PC_QUERY).matches;
    var src = isPc ? video.dataset.srcPc : video.dataset.srcSp;
    var poster = isPc ? video.dataset.posterPc : video.dataset.posterSp;

    if (poster) video.setAttribute('poster', poster);
    if (!src) return;

    video.dataset.rbVideoReady = '1';
    video.setAttribute('preload', 'metadata');
    video.src = src;

    var play = video.play();
    if (play && typeof play.catch === 'function') {
      // 自動再生が拒否された場合はポスター画像のままにする
      play.catch(function () {});
    }
  }

  function init() {
    var videos = document.querySelectorAll('video[data-rb-video]');
    if (!videos.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) return;

    Array.prototype.forEach.call(videos, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションを読み込み直したときにも効かせる
  document.addEventListener('shopify:section:load', init);
})();


/* ==========================================================================
   メルマガ登録モーダル（sections/rb-newsletter-modal.liquid）
   2026-08-31 五十嵐 新規作成

   表示の決まりごと
     - テーマエディタで開いている間は、条件を無視して常に出す（編集できるように）
     - 閉じたら設定日数のあいだ出さない
     - 登録が完了したら以後ずっと出さない
     - 「指定秒数の経過」か「指定量までスクロール」の早い方で出す
   ========================================================================== */
(function () {
  var DISMISS_KEY = 'rb_nlm_dismissed_until';
  var DONE_KEY = 'rb_nlm_subscribed';
  // 送信直前に立てる目印。フッターの登録フォームも同じ {% form 'customer' %} を
  // 使うため、Liquid の form.posted_successfully? だけでは送信元を区別できない。
  // この目印があるときだけ、モーダルを完了表示で開く。
  var SUBMIT_KEY = 'rb_nlm_submitting';

  // プライベートブラウジング等で localStorage が例外を投げることがあるので、
  // 読み書きは必ず包んで、失敗しても表示自体は壊れないようにする。
  function readStore(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* 保存できなくても動作は続ける */
    }
  }

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      /* 同上 */
    }
  }

  function clearSession(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {
      /* 同上 */
    }
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function setup(root) {
    if (root.dataset.rbNlmReady === '1') return;
    root.dataset.rbNlmReady = '1';

    var dialog = root.querySelector('.rb-nlm__dialog');
    var form = root.querySelector('.rb-nlm__form');
    var input = root.querySelector('.rb-nlm__input');
    var fromModal = readSession(SUBMIT_KEY) === '1';
    var succeeded = !!root.querySelector('[data-rb-nlm-success]') && fromModal;
    var failed = !!root.querySelector('.rb-nlm__error') && fromModal;
    clearSession(SUBMIT_KEY);

    // 送信するとページが再読み込みされるので、その前に「モーダルから出した」
    // 印を残しておく
    if (form) {
      form.addEventListener('submit', function () {
        writeSession(SUBMIT_KEY, '1');
      });
    }
    var design = isDesignMode();
    var lastFocused = null;
    var timer = null;
    var opened = false;

    function open() {
      if (opened) return;
      opened = true;
      if (timer) window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);

      lastFocused = document.activeElement;
      root.removeAttribute('hidden');
      // hidden を外した直後だと transition が走らないので、
      // 1フレーム置いてからクラスを付ける
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.addEventListener('keydown', onKeydown);

      // スマホで入力欄にフォーカスするとキーボードが勝手にせり上がって
      // 画面が隠れるので、自動フォーカスはPCだけにする
      if (input && window.matchMedia('(min-width: 750px)').matches) {
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          input.focus();
        }
      }
    }

    function close() {
      if (!opened) return;
      opened = false;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown);

      // フェードアウトが終わってから hidden に戻す
      window.setTimeout(function () {
        if (!opened) root.setAttribute('hidden', '');
      }, 350);

      if (!design) {
        if (root.dataset.reshow === 'days') {
          var days = parseInt(root.dataset.suppressDays, 10);
          if (!isFinite(days) || days < 1) days = 90;
          writeStore(DISMISS_KEY, String(Date.now() + days * 86400000));
        } else {
          // 初回のみ表示。閉じた時点で以後は出さない。
          // 導線はフッター直上の共通セクションに常設してあるので取りこぼさない。
          writeStore(DONE_KEY, '1');
        }
      }

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        close();
        return;
      }
      if (event.key !== 'Tab' || !dialog) return;

      // モーダルの外へタブで抜けないよう、先頭と末尾で折り返す
      var focusable = dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onScroll() {
      var percent = parseInt(root.dataset.scroll, 10);
      if (!isFinite(percent) || percent <= 0) return;

      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      if ((window.scrollY / scrollable) * 100 >= percent) open();
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-rb-nlm-close]'), function (el) {
      el.addEventListener('click', close);
    });

    // --- ここから表示するかどうかの判定 ---

    // 登録が完了して戻ってきた時は、条件を問わず完了メッセージを見せる
    if (succeeded) {
      writeStore(DONE_KEY, '1');
      open();
      return;
    }

    // 入力エラーで戻ってきた時も、直し方が分かるよう開き直す
    if (failed) {
      open();
      return;
    }

    // テーマエディタでは条件を無視して即座に出す（文言を編集できるように）
    if (design) {
      open();
      return;
    }

    if (readStore(DONE_KEY) === '1') return;

    var until = parseInt(readStore(DISMISS_KEY), 10);
    if (isFinite(until) && Date.now() < until) return;

    if (root.dataset.display === 'index' && root.dataset.template !== 'index') return;

    var delay = parseInt(root.dataset.delay, 10);
    if (!isFinite(delay) || delay < 0) delay = 5;
    timer = window.setTimeout(open, delay * 1000);

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-rb-newsletter-modal]'),
      setup
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
